import SafetextSender from "../misc/safetextSender";
import ActionTypes from "../actions/actionTypes";

export const SIP_STATE = {
  UNREGISTERED: "UNREGISTERED",
  IDLE: "IDLE",
  IN_CALL: "IN_CALL",
};

export const CALL_STATE = {
  CALLING: "CALLING",
  INCOMING_CALL: "INCOMING_CALL",
  ACCEPTED: "ACCEPTED",
  REJECTED_LOCAL: "REJECTED_LOCAL",
  REJECTED_REMOTE: "REJECTED_REMOTE",
  CANCELED_LOCAL: "CANCELED_LOCAL",
  CANCELED_REMOTE: "CANCELED_REMOTE",
  FAILED: "FAILED",
  TERMINATED_LOCAL: "TERMINATED_LOCAL",
  TERMINATED_REMOTE: "TERMINATED_REMOTE",
};

const initialState = {
  userAgent: null,
  userAgentOptions: {},
  session: null,
  sipState: SIP_STATE.UNREGISTERED,
  callState: null,
  MMXCALLID: null,
  MMXTEXTSEQ: 0,
  online: true,
  negotiated: { audio: false, video: false, text: false },
  safetextSender: new SafetextSender(),
};

var callid = null;

const sipReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SIP_ONLINE:
      //Remote peer making call (WE ARE BEING CALLED)
      state = {
        ...state,
        online: action.payload,
      };
      break;
    case ActionTypes.SIP_INVITE_RECIEVED:
      //Remote peer making call (WE ARE BEING CALLED)
      state = {
        ...state,
        sipState: SIP_STATE.IN_CALL,
        callState: CALL_STATE.INCOMING_CALL,
        session: action.payload.session,
      };
      break;
    case ActionTypes.SIP_CALLING:
      //Local peer making call (WE ARE CALLING)
      state = {
        ...state,
        sipState: SIP_STATE.IN_CALL,
        callState: CALL_STATE.CALLING,
        session: action.payload.session,
      };
      break;
    case ActionTypes.SIP_CALL_ACCEPTED_LOCAL:
      callid = action.payload.MMXCALLID
        ? action.payload.MMXCALLID
        : state.MMXCALLID;
      state = {
        ...state,
        callState: CALL_STATE.ESTABLISHING,
        sipState: SIP_STATE.IN_CALL,
        negotiated: action.payload.negotiated,
        MMXCALLID: callid,
      };
      break;
    case ActionTypes.SIP_CALL_ACCEPTED_REMOTE:
      callid = action.payload.MMXCALLID
        ? action.payload.MMXCALLID
        : state.MMXCALLID;
      state = {
        ...state,
        callState: CALL_STATE.ACCEPTED,
        sipState: SIP_STATE.IN_CALL,
        negotiated: action.payload.negotiated,
        MMXCALLID: callid,
      };
      break;
    case ActionTypes.SIP_CALL_SET_NEGOTIATED:
      callid = action.payload.MMXCALLID
        ? action.payload.MMXCALLID
        : state.MMXCALLID;
      state = {
        ...state,
        callState: CALL_STATE.ACCEPTED,
        negotiated: action.payload.negotiated,
        MMXCALLID: callid,
      };
      break;
    case ActionTypes.SIP_CALL_CANCELED_LOCAL:
      //Outgoing call was canceled by local peer (WE HUNG UP)
      state = {
        ...state,
        callState: CALL_STATE.CANCELED_LOCAL,
        sipState: SIP_STATE.IDLE,
      };
      break;
    case ActionTypes.SIP_CALL_CANCELED_REMOTE:
      //incoming call was canceled by remote peer (THEY HUNG UP)
      state = {
        ...state,
        callState: CALL_STATE.CANCELED_REMOTE,
        sipState: SIP_STATE.IN_CALL,
      };
      break;
    case ActionTypes.SIP_CALL_REJECTED_LOCAL:
      //Call was rejected by local peer (unsucessful final response) (WE REJECTED THE CALL)
      state = {
        ...state,
        callState: CALL_STATE.REJECTED_REMOTE,
        sipState: SIP_STATE.IDLE,
      };
      break;
    case ActionTypes.SIP_CALL_REJECTED_REMOTE:
      //Call was rejected by remote peer (unsucessful final response) (THEY REJECTED THE CALL)
      state = {
        ...state,
        callState: CALL_STATE.REJECTED_REMOTE,
        sipState: SIP_STATE.IN_CALL,
      };
      break;
    case ActionTypes.SIP_CALL_FAILED_REMOTE:
      //Call failed, due to unsucessful final response or timeout (CALL WAS NOT SUCCESSFUL)
      state = {
        ...state,
        callState: CALL_STATE.FAILED,
        sipState: SIP_STATE.IDLE,
      };
      break;
    case ActionTypes.SIP_CALL_FAILED:
      state = {
        ...state,
        callState: CALL_STATE.FAILED,
        sipState: SIP_STATE.IN_CALL,
      };
      break;
    case ActionTypes.SIP_CALL_TERMINATED_LOCAL:
      //Call was terminated (CALL WAS ENDED WITH A BYE)
      state = {
        ...state,
        callState: CALL_STATE.TERMINATED_LOCAL,
        sipState: SIP_STATE.IN_CALL,
      };
      break;
    case ActionTypes.SIP_CALL_TERMINATED_REMOTE:
      //Call was terminated (CALL WAS ENDED WITH A BYE)
      state = {
        ...state,
        callState: CALL_STATE.TERMINATED_REMOTE,
        sipState: SIP_STATE.IN_CALL,
      };
      break;
    case ActionTypes.SIP_CALL_COMPLETED:
      //Call was completed
      state = {
        ...state,
        sipState: SIP_STATE.IDLE,
      };
      break;
    case ActionTypes.SIP_MESSAGE_SENT:
      var textseq = state.MMXTEXTSEQ++;
      state = {
        ...state,
        MMXTEXTSEQ: textseq,
      };
      break;
    case ActionTypes.SIP_UPDATE_OPTIONS:
      state = {
        ...state,
        userAgentOptions: action.payload.userAgentOptions,
      };
      break;
    case ActionTypes.SIP_REGISTER_STARTED:
      state = {
        ...state,
        userAgent: action.payload.userAgent,
      };
      break;
    case ActionTypes.SIP_REGISTER_SUCCESS:
      state = {
        ...state,
        userAgent: action.payload.userAgent,
        sipState: SIP_STATE.IDLE,
        online: true,
      };
      break;
    case ActionTypes.SIP_REGISTER_FAILED:
      state = {
        ...state,
      };
      break;
    case ActionTypes.SIP_UNREGISTERED:
      state = {
        ...state,
      };
      break;
    case ActionTypes.SIP_LOGOUT:
      state = {
        ...state,
        userAgent: null,
        online: false,
      };
      break;
    default:
      break;
  }
  return state;
};

export default sipReducer;






// WEBPACK FOOTER //
// ./src/reducers/sipReducer.js